<div id="onboarding-address-page">

  <app-onboarding-stepper [currentStep]="2"></app-onboarding-stepper>
  <app-onboarding-header
    title="Étape 2 : Adresse"
    content="L'adresse renseignée sera celle où le matériel sera livré. Veuillez préciser si cette adresse servira également pour la facturation. ">
  </app-onboarding-header>

  <div class="container-error-block" *ngIf="error">
    {{ error.code | translate }}
  </div>

  <form *ngIf="addressesForm" [formGroup]="addressesForm" (submit)="createAddresses()">
    <div class="form-group-title" [hidden]="useSameAddress">
      Adresse d’installation
    </div>
    <div formGroupName="installationAddress">
      <mat-form-field>
        <mat-label>Adresse</mat-label>
        <input matInput placeholder="Saississez l'adresse complète" formControlName="street" #installationAddress/>
        <mat-error *ngIf="addressesForm.controls['installationAddress'].get('street')?.hasError('required')">
          Champ obligatoire.
        </mat-error>
      </mat-form-field>
      <div class="container-flex-input">
        <mat-form-field>
          <mat-label>Code postal</mat-label>
          <input matInput type="text" placeholder="Saisissez un code postal" formControlName="zipCode">
          <mat-error *ngIf="addressesForm.controls['installationAddress'].get('zipCode')?.hasError('required')">
            Champ obligatoire.
          </mat-error>
          <mat-error *ngIf="addressesForm.controls['installationAddress'].get('zipCode')?.hasError('pattern')">
            Code postal invalide (ex: 75000).
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ville</mat-label>
          <input matInput placeholder="Saisissez une ville" type="text" formControlName="city">
          <mat-error *ngIf="addressesForm.controls['installationAddress'].get('city')?.hasError('required')">
            Champ obligatoire.
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Pays</mat-label>
        <input matInput placeholder="Saisissez un pays" formControlName="country"/>
        <mat-error *ngIf="addressesForm.controls['installationAddress'].get('country')?.hasError('required')">
          Champ obligatoire.
        </mat-error>
        <mat-error *ngIf="addressesForm.controls['installationAddress'].get('country')?.hasError('pattern')">
          L'adresse doit obligatoirement être en France.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Informations complémentaires</mat-label>
        <textarea matInput
                  placeholder="Vous pouvez nous indiquer des informations complémentaires concernant votre adresse"
                  formControlName="infos">
        </textarea>
      </mat-form-field>
    </div>

    <mat-checkbox (change)="toggleAddress()" [checked]="useSameAddress">
      L’adresse de livraison et facturation sont identiques.
    </mat-checkbox>

    <div class="form-group-title" [hidden]="useSameAddress">
      Adresse de facturation
    </div>
    <div [hidden]="useSameAddress" formGroupName="billingAddress">
      <mat-form-field>
        <mat-label>Adresse</mat-label>
        <input matInput placeholder="Saississez l'adresse complète" formControlName="street" #billingAddress/>
        <mat-error *ngIf="addressesForm.controls['billingAddress'].get('street')?.hasError('required')">
          Champ obligatoire.
        </mat-error>
      </mat-form-field>
      <div class="container-flex-input">
        <mat-form-field>
          <mat-label>Code postal</mat-label>
          <input matInput type="text" placeholder="Saisissez un code postal" formControlName="zipCode">
          <mat-error *ngIf="addressesForm.controls['billingAddress'].get('zipCode')?.hasError('required')">
            Champ obligatoire.
          </mat-error>
          <mat-error *ngIf="addressesForm.controls['billingAddress'].get('zipCode')?.hasError('pattern')">
            Code postal invalide (ex: 75000).
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ville</mat-label>
          <input matInput placeholder="Saisissez une ville" type="text" formControlName="city">
          <mat-error *ngIf="addressesForm.controls['billingAddress'].get('city')?.hasError('required')">
            Champ obligatoire.
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Pays</mat-label>
        <input matInput placeholder="Saisissez un pays" formControlName="country"/>
        <mat-error *ngIf="addressesForm.controls['billingAddress'].get('country')?.hasError('required')">
          Champ obligatoire.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Informations complémentaires</mat-label>
        <textarea matInput
                  placeholder="Vous pouvez nous indiquer des informations complémentaires concernant votre adresse"
                  formControlName="infos"></textarea>
      </mat-form-field>
    </div>
    <div class="container-actions">
      <button mat-stroked-button (click)="previousStep()"
              class="base"
              type="button">
        Retour
      </button>
      <button mat-flat-button
              color="accent"
              type="submit"
              [disabled]="!addressesForm.valid || isLoading">
        <div *ngIf="!isLoading">
          <div class="icon">
            Suivant <img ngSrc="assets/images/icons/white/arrow-right.svg" alt="Icon arrow right" width="24" height="24">
          </div>
        </div>
        <div *ngIf="isLoading">
          <div class="icon">
            Suivant <mat-spinner [diameter]="24"></mat-spinner>
          </div>
        </div>
      </button>
    </div>
  </form>
</div>
